import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { evanstonConfig } from "./data";

export default function EvanstonPage() {
  return <CityPageTemplate config={evanstonConfig} />;
}